!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("flex-insights-identity-client", [], t) : "object" == typeof exports ? exports["flex-insights-identity-client"] = t() : e["flex-insights-identity-client"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 8);
  }([function (e, t, r) {
    e.exports = r(6);
  }, function (e, t) {
    function r(e, t, r, n, o, i, s) {
      try {
        var a = e[i](s),
            u = a.value;
      } catch (e) {
        return void r(e);
      }

      a.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    e.exports = function (e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (o, i) {
          var s = e.apply(t, n);

          function a(e) {
            r(s, o, i, a, u, "next", e);
          }

          function u(e) {
            r(s, o, i, a, u, "throw", e);
          }

          a(void 0);
        });
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = {};

      function r(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }

      return r.m = e, r.c = t, r.d = function (e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, r.t = function (e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) {
          r.d(n, o, function (t) {
            return e[t];
          }.bind(null, o));
        }
        return n;
      }, r.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return r.d(t, "a", t), t;
      }, r.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, r.p = "", r(r.s = 0);
    }([function (e, t, r) {
      e.exports = r(1);
    }, function (e, t) {
      function r(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var n = "ytica-js-logger:enabled",
          o = {};

      function i(e, t) {
        if (this.isBrowser && !this.isEnabled) return !1;
        var r = this.options.formatter(Array.prototype.slice.call(t), this);
        this.options.logHandler && this.enabledFor(e) && this.options.logHandler(r, e), this.options.afterLog.call(this, r, e);
      }

      function s(e, t) {
        if ("undefined" != typeof console) {
          var r = console.log;
          t === o.ERROR && console.error ? r = console.error : t === o.WARN && console.warn ? r = console.warn : t === o.INFO && console.info ? r = console.info : t === o.DEBUG && console.debug && (r = console.debug), function (e, t) {
            Function.prototype.apply.call(e, console, t);
          }(r, e);
        }
      }

      function a(e, t) {
        return e.unshift("[".concat(t.options.name, "]")), e;
      }

      o.DEBUG = {
        value: 0,
        name: "DEBUG"
      }, o.INFO = {
        value: 1,
        name: "INFO"
      }, o.WARN = {
        value: 2,
        name: "WARN"
      }, o.ERROR = {
        value: 3,
        name: "ERROR"
      };

      var u = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e);
          var r,
              i,
              u = {
            level: o.INFO,
            logHandler: s,
            afterLog: function afterLog() {},
            suppress: [],
            formatter: a
          };
          this.options = Object.assign({}, u, t), this.isBrowser && (i = (r = {
            enabled: !0
          }).enabled, r.logLevel, localStorage.getItem(n) || localStorage.setItem(n, i));
        }

        var t, u, c;
        return t = e, c = [{
          key: "DEBUG",
          get: function get() {
            return o.DEBUG;
          }
        }, {
          key: "INFO",
          get: function get() {
            return o.INFO;
          }
        }, {
          key: "WARN",
          get: function get() {
            return o.WARN;
          }
        }, {
          key: "ERROR",
          get: function get() {
            return o.ERROR;
          }
        }], (u = [{
          key: "enabledFor",
          value: function value(e) {
            var t = this.localStorageDefaultLevel || this.options.level,
                r = e.value >= t.value,
                n = this.options.suppress.includes(e);
            return r && !n;
          }
        }, {
          key: "debug",
          value: function value() {
            i.call(this, o.DEBUG, arguments);
          }
        }, {
          key: "info",
          value: function value() {
            i.call(this, o.INFO, arguments);
          }
        }, {
          key: "log",
          value: function value() {
            i.call(this, o.INFO, arguments);
          }
        }, {
          key: "warn",
          value: function value() {
            i.call(this, o.WARN, arguments);
          }
        }, {
          key: "error",
          value: function value() {
            i.call(this, o.ERROR, arguments);
          }
        }, {
          key: "isEnabled",
          get: function get() {
            return JSON.parse(localStorage.getItem(n));
          }
        }, {
          key: "localStorageDefaultLevel",
          get: function get() {
            var e = localStorage.getItem("ytica-js-logger:logLevel");
            return o[e];
          }
        }, {
          key: "isBrowser",
          get: function get() {
            return "undefined" != typeof window;
          }
        }]) && r(t.prototype, u), c && r(t, c), e;
      }();

      e.exports = u;
    }]);
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function r(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    e.exports = function (e, t, n) {
      return t && r(e.prototype, t), n && r(e, n), e;
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    };
  }, function (e, t, r) {
    var n = function () {
      return this || "object" == typeof self && self;
    }() || Function("return this")(),
        o = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0,
        i = o && n.regeneratorRuntime;

    if (n.regeneratorRuntime = void 0, e.exports = r(7), o) n.regeneratorRuntime = i;else try {
      delete n.regeneratorRuntime;
    } catch (e) {
      n.regeneratorRuntime = void 0;
    }
  }, function (e, t) {
    !function (t) {
      "use strict";

      var r,
          n = Object.prototype,
          o = n.hasOwnProperty,
          i = "function" == typeof Symbol ? Symbol : {},
          s = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag",
          c = "object" == typeof e,
          l = t.regeneratorRuntime;
      if (l) c && (e.exports = l);else {
        (l = t.regeneratorRuntime = c ? e.exports : {}).wrap = _;
        var h = "suspendedStart",
            f = "suspendedYield",
            d = "executing",
            g = "completed",
            p = {},
            v = {};

        v[s] = function () {
          return this;
        };

        var k = Object.getPrototypeOf,
            y = k && k(k(E([])));
        y && y !== n && o.call(y, s) && (v = y);
        var m = w.prototype = S.prototype = Object.create(v);
        P.prototype = m.constructor = w, w.constructor = P, w[u] = P.displayName = "GeneratorFunction", l.isGeneratorFunction = function (e) {
          var t = "function" == typeof e && e.constructor;
          return !!t && (t === P || "GeneratorFunction" === (t.displayName || t.name));
        }, l.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, w) : (e.__proto__ = w, u in e || (e[u] = "GeneratorFunction")), e.prototype = Object.create(m), e;
        }, l.awrap = function (e) {
          return {
            __await: e
          };
        }, L(T.prototype), T.prototype[a] = function () {
          return this;
        }, l.AsyncIterator = T, l.async = function (e, t, r, n) {
          var o = new T(_(e, t, r, n));
          return l.isGeneratorFunction(t) ? o : o.next().then(function (e) {
            return e.done ? e.value : o.next();
          });
        }, L(m), m[u] = "Generator", m[s] = function () {
          return this;
        }, m.toString = function () {
          return "[object Generator]";
        }, l.keys = function (e) {
          var t = [];

          for (var r in e) {
            t.push(r);
          }

          return t.reverse(), function r() {
            for (; t.length;) {
              var n = t.pop();
              if (n in e) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, l.values = E, I.prototype = {
          constructor: I,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(O), !e) for (var t in this) {
              "t" === t.charAt(0) && o.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = r);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var t = this;

            function n(n, o) {
              return a.type = "throw", a.arg = e, t.next = n, o && (t.method = "next", t.arg = r), !!o;
            }

            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var s = this.tryEntries[i],
                  a = s.completion;
              if ("root" === s.tryLoc) return n("end");

              if (s.tryLoc <= this.prev) {
                var u = o.call(s, "catchLoc"),
                    c = o.call(s, "finallyLoc");

                if (u && c) {
                  if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                  if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                } else if (u) {
                  if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var n = this.tryEntries[r];

              if (n.tryLoc <= this.prev && o.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                var i = n;
                break;
              }
            }

            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
            var s = i ? i.completion : {};
            return s.type = e, s.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, p) : this.complete(s);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), p;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var r = this.tryEntries[t];
              if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), O(r), p;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var r = this.tryEntries[t];

              if (r.tryLoc === e) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var o = n.arg;
                  O(r);
                }

                return o;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, t, n) {
            return this.delegate = {
              iterator: E(e),
              resultName: t,
              nextLoc: n
            }, "next" === this.method && (this.arg = r), p;
          }
        };
      }

      function _(e, t, r, n) {
        var o = t && t.prototype instanceof S ? t : S,
            i = Object.create(o.prototype),
            s = new I(n || []);
        return i._invoke = function (e, t, r) {
          var n = h;
          return function (o, i) {
            if (n === d) throw new Error("Generator is already running");

            if (n === g) {
              if ("throw" === o) throw i;
              return j();
            }

            for (r.method = o, r.arg = i;;) {
              var s = r.delegate;

              if (s) {
                var a = b(s, r);

                if (a) {
                  if (a === p) continue;
                  return a;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === h) throw n = g, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = d;
              var u = R(e, t, r);

              if ("normal" === u.type) {
                if (n = r.done ? g : f, u.arg === p) continue;
                return {
                  value: u.arg,
                  done: r.done
                };
              }

              "throw" === u.type && (n = g, r.method = "throw", r.arg = u.arg);
            }
          };
        }(e, r, s), i;
      }

      function R(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      function S() {}

      function P() {}

      function w() {}

      function L(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function T(e) {
        var t;

        this._invoke = function (r, n) {
          function i() {
            return new Promise(function (t, i) {
              !function t(r, n, i, s) {
                var a = R(e[r], e, n);

                if ("throw" !== a.type) {
                  var u = a.arg,
                      c = u.value;
                  return c && "object" == typeof c && o.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                    t("next", e, i, s);
                  }, function (e) {
                    t("throw", e, i, s);
                  }) : Promise.resolve(c).then(function (e) {
                    u.value = e, i(u);
                  }, function (e) {
                    return t("throw", e, i, s);
                  });
                }

                s(a.arg);
              }(r, n, t, i);
            });
          }

          return t = t ? t.then(i, i) : i();
        };
      }

      function b(e, t) {
        var n = e.iterator[t.method];

        if (n === r) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = r, b(e, t), "throw" === t.method)) return p;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return p;
        }

        var o = R(n, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, p;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = r), t.delegate = null, p) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, p);
      }

      function x(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function O(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function I(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(x, this), this.reset(!0);
      }

      function E(e) {
        if (e) {
          var t = e[s];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var n = -1,
                i = function t() {
              for (; ++n < e.length;) {
                if (o.call(e, n)) return t.value = e[n], t.done = !1, t;
              }

              return t.value = r, t.done = !0, t;
            };

            return i.next = i;
          }
        }

        return {
          next: j
        };
      }

      function j() {
        return {
          value: r,
          done: !0
        };
      }
    }(function () {
      return this || "object" == typeof self && self;
    }() || Function("return this")());
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(0),
        i = n.n(o),
        s = n(1),
        a = n.n(s),
        u = n(3),
        c = n.n(u),
        l = n(4),
        h = n.n(l),
        f = n(5),
        d = n.n(f),
        g = n(2),
        p = n.n(g),
        v = new p.a({
      name: "Identity",
      level: p.a.ERROR
    });

    function k(e) {
      var t = e.split(".")[1].replace("-", "+").replace("_", "/");
      return JSON.parse(window.atob(t));
    }

    var y = {
      url: "/api",
      loginUrl: "/signin",
      logoutUrl: "/signout",
      refreshUrl: "/renew-token",
      userinfoUrl: "/userinfo",
      serviceSsoUrl: "/sso-url",
      authSsoUrl: "/sso-auth",
      oauthSsoUrl: "/sso-oauth",
      switchAccountUrl: "/switch-account",
      ssoLoginUrl: "https://apigw.ytica.com/provisioning/token-generator",
      accessToken: "authorization_token",
      refreshToken: "refresh_token",
      refreshBeforeExpireSec: 3e4,
      unauthorizedRedirect: null,
      redirect: null,
      scope: "",
      tokenPairLocalStorageKey: "ytica-identity-client-vue:tokenPair",
      accessTokenLocalStorageKey: "ytica-identity-client-vue:accessToken",
      refreshTokenLockLocalStorageKey: "ytica-identity-client-vue:refreshTokenLock",
      refreshTokenLockTimeout: 3e4,
      refreshTokenLocalStorageKey: "ytica-identity-client-vue:refreshToken",
      clockSkewStorageKey: "ytica-identity-client-vue:clockSkew",
      baseUrl: ""
    },
        m = {
      expires: null,
      user: null,
      jwtPayload: null,
      notBefore: null,
      issuedAt: null,
      loading: !1,
      checking: !1,
      isLoggedIn: !1,
      uniqueId: null,
      idthrdOrder: null,
      refreshTimeoutId: null,
      runningRefreshPromise: null,
      runningRefreshPromiseResolve: null,
      refreshToken: null,
      accessToken: null,
      tokenPair: {
        accessToken: null,
        refreshToken: null
      },
      clockSkew: null
    },
        _ = function () {
      function e(t) {
        var r = this;
        c()(this, e), d()(this, "_setAccessToken", function (e) {
          r.accessToken = e, v.log("Set new accessToken"), r._parseJWT(r.accessToken), r._updateLoggedInStatus();
        }), this.options = Object.assign(y, t), this.axios = t.axios, this.axios || v.error("Axios was not passed to identity client."), this.onPropertyUpdated = t.onPropertyUpdated, this.onLoggedInChanged = t.onLoggedInChanged;
      }

      return h()(e, [{
        key: "_created",
        value: function value() {
          this._defineData(m), this._defineReactiveProperties(), this._defineLocalStorageProperties(), this._addLocalStorageEventListener(), this._initializeInterceptors();

          var e = this._getTokenPairFromLocalStorage();

          e.accessToken && e.refreshToken && (this.tokenPair = e), this._clearOldIdthrd(), this._setUniqueId(), v.log("ytica-identity-client-vue created [".concat(this.uniqueId, "]")), this._updateIdthrdOrder(), window.addEventListener("beforeunload", this._clearStorage.bind(this));
        }
      }, {
        key: "_createReactiveProperty",
        value: function value(e) {
          return {
            set: function set(t) {
              if (this[e] = t, "function" == typeof this.onPropertyUpdated) {
                var r = e.replace("_", "");
                this.onPropertyUpdated({
                  name: r,
                  value: t
                });
              }
            },
            get: function get() {
              return this[e];
            }
          };
        }
      }, {
        key: "_defineReactiveProperties",
        value: function value() {
          Object.defineProperties(this, {
            expires: this._createReactiveProperty("_expires"),
            user: this._createReactiveProperty("_user"),
            jwtPayload: this._createReactiveProperty("_jwtPayload"),
            notBefore: this._createReactiveProperty("_notBefore"),
            issuedAt: this._createReactiveProperty("_issuedAt"),
            loading: this._createReactiveProperty("_loading"),
            checking: this._createReactiveProperty("_checking"),
            isLoggedIn: this._createReactiveProperty("_isLoggedIn"),
            uniqueId: this._createReactiveProperty("_uniqueId"),
            idthrdOrder: this._createReactiveProperty("_idthrdOrder"),
            refreshTimeoutId: this._createReactiveProperty("_refreshTimeoutId"),
            runningRefreshPromise: this._createReactiveProperty("_runningRefreshPromise"),
            runningRefreshPromiseResolve: this._createReactiveProperty("_runningRefreshPromiseResolve"),
            accessToken: this._createReactiveProperty("_accessToken"),
            refreshToken: this._createReactiveProperty("_refreshToken")
          });
        }
      }, {
        key: "_defineData",
        value: function value(e) {
          var t = this;
          Object.keys(e).forEach(function (r) {
            t[r] = e[r];
          });
        }
      }, {
        key: "_defineLocalStorageProperties",
        value: function value() {
          "function" === this.onPropertyUpdated && this.onPropertyUpdated({
            name: "clockSkew",
            value: parseInt(localStorage.getItem(this.options.clockSkewStorageKey) || 0)
          });
          var e = this;
          Object.defineProperty(e, "tokenPair", {
            set: function set(t) {
              v.log("tokenPair set"), t && t.accessToken ? e._isTokenOlder(t.accessToken, e.accessToken) || (e._setRefreshToken(t.refreshToken), e._setAccessToken(t.accessToken), "function" == typeof e.onPropertyUpdated && e.onPropertyUpdated({
                name: "tokenPair",
                value: t
              })) : (e.isLoggedIn && (e._clearRunningRefreshPromise(), e.logout()), "function" == typeof e.onPropertyUpdated && e.onPropertyUpdated({
                name: "tokenPair",
                value: t
              })), e._setTokenPairToLocalStorage(t);
            },
            get: function get() {
              return e._getTokenPairFromLocalStorage();
            }
          }), Object.defineProperty(e, "clockSkew", {
            set: function set(t) {
              v.log("clockSkew set:", t), t ? (localStorage.setItem(e.options.clockSkewStorageKey, t), "function" == typeof e.onPropertyUpdated && e.onPropertyUpdated({
                name: "clockSkew",
                value: t
              })) : (localStorage.removeItem(e.options.clockSkewStorageKey), "function" == typeof e.onPropertyUpdated && e.onPropertyUpdated({
                name: "clockSkew",
                value: null
              }));
            },
            get: function get() {
              return parseInt(localStorage.getItem(e.options.clockSkewStorageKey) || 0);
            }
          });
        }
      }, {
        key: "_getTokenPairFromLocalStorage",
        value: function value() {
          var e = localStorage.getItem(this.options.tokenPairLocalStorageKey);
          return e ? JSON.parse(e) : {
            accessToken: null,
            refreshToken: null
          };
        }
      }, {
        key: "_setTokenPairToLocalStorage",
        value: function value(e) {
          localStorage.setItem(this.options.tokenPairLocalStorageKey, JSON.stringify(e));
        }
      }, {
        key: "_clearOldIdthrd",
        value: function value() {
          Object.keys(localStorage).filter(function (e) {
            return e.startsWith("idthrd:");
          }).forEach(function (e) {
            localStorage.removeItem(e);
          });
        }
      }, {
        key: "_setUniqueId",
        value: function value() {
          this.uniqueId = Date.now() + ":" + (1e9 * Math.random() | 0), this._updateIdthrdOrder();
        }
      }, {
        key: "_updateIdthrdOrder",
        value: function value() {
          var e = null,
              t = !1,
              r = Object.keys(localStorage).filter(function (e) {
            return e.startsWith("idthrd:");
          });
          r.sort(), v.log("idthrdKeysLS =", r);

          for (var n = 0; n < r.length; n++) {
            if (r[n] === this.idthrd) {
              e = n, v.log("updateIdthrdOrder break order =", e);
              break;
            }
          }

          if (null === e) {
            t = !0, r.push(this.idthrd), r.sort(), v.log("idthrdKeysLS extended =", r);

            for (var o = 0; o < r.length; o++) {
              if (r[o] === this.idthrd) {
                e = o, v.log("updateIdthrdOrder break order =", e);
                break;
              }
            }
          }

          (t || null === this.idthrdOrder || this.idthrdOrder !== e) && (this.idthrdOrder = e, v.log("updateIdthrdOrder", this.idthrd, this.idthrdOrder), localStorage.setItem(this.idthrd, this.idthrdOrder));
        }
      }, {
        key: "_clearStorage",
        value: function value() {
          v.log("ytica-identity-client-vue onbeforeunload [".concat(this.idthrd, "]")), localStorage.getItem(this.options.refreshTokenLockLocalStorageKey) === this.uniqueId && localStorage.removeItem(this.options.refreshTokenLockLocalStorageKey), localStorage.removeItem(this.idthrd);
        }
      }, {
        key: "_updateLoggedInStatus",
        value: function value() {
          var e = this.isLoggedIn;
          this.isLoggedIn = this._isTokenValid() && !!this.user, v.log("updateLoggedInStatus ", e, "=>", this.isLoggedIn), v.log(this), this.onLoggedInChanged && this.onLoggedInChanged(e, this.isLoggedIn);
        }
      }, {
        key: "_isTokenValid",
        value: function value() {
          return v.log("isTokenValid. clockSkew", this.clockSkew, "\nisTokenValid. expires", new Date(1e3 * this.expires).toJSON(), "\nisTokenValid. expires + clockSkew", new Date(1e3 * (this.expires + this.clockSkew)).toJSON(), "\nisTokenValid. Date.now() ", new Date(Date.now()).toJSON(), "\nisTokenValid. (this.expires * 1000) - Date.now() ", 1e3 * this.expires - Date.now(), "\nisTokenValid. ((this.expires + this.clockSkew - 1)* 1000) - Date.now() ", 1e3 * (this.expires + this.clockSkew - 1) - Date.now()), !!this.accessToken && 1e3 * (this.expires + this.clockSkew - 1) - Date.now() > 0;
        }
      }, {
        key: "_addLocalStorageEventListener",
        value: function value() {
          var e = this;
          window.addEventListener("storage", function (t) {
            if (v.log("LocalStorage event e.key:", t.key, ", newValue!==e.oldValue: ", t.newValue !== t.oldValue, ", ", t.oldValue, "->", t.newValue), t.key === e.options.tokenPairLocalStorageKey) t.newValue !== t.oldValue && (e.tokenPair = e._getTokenPairFromLocalStorage());else if (t.key === e.options.refreshTokenLockLocalStorageKey) {
              if (!t.newValue) {
                var r = e._getRandomTimeout();

                setTimeout(function () {
                  v.log("UNLOCK other", r), e._resolveRunningRefreshPromise("unlock other");
                }, r);
              }
            } else t.key.startsWith("idthrd:") && e._updateIdthrdOrder();
          });
        }
      }, {
        key: "_initializeInterceptors",
        value: function value() {
          var e,
              t = this,
              r = this;
          this.axios.interceptors.request.use((e = a()(i.a.mark(function e(n) {
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (v.log("Request interceptor ".concat(n.url)), !t.runningRefreshPromiseResolve || n.url !== r._uri("refresh")) {
                      e.next = 4;
                      break;
                    }

                    return v.log("Request interceptor: runningRefreshPromiseResolve not null, cancelling request ".concat(n.url)), e.abrupt("return", Promise.reject("Parallel request to ".concat(n.url, " cancelled")));

                  case 4:
                    if (!0 === n.noAuth || n.url === r._uri("login") || n.url === r._uri("authSso") || n.url === r._uri("oauthSso") || n.url === r.options.ssoLoginUrl) {
                      e.next = 16;
                      break;
                    }

                    if (n.url === r._uri("refresh") || n.url === r._uri("serviceSso") && n.data && "talkdesk" === n.data.target_sso) {
                      e.next = 10;
                      break;
                    }

                    return v.log("Request interceptor before self.authenticate"), e.next = 9, r.authenticate();

                  case 9:
                    v.log("Request interceptor after self.authenticate");

                  case 10:
                    if (n.url === r._uri("refresh") || n.url === r._uri("serviceSso") || n.url === r._uri("logout")) {
                      e.next = 14;
                      break;
                    }

                    return v.log("Request interceptor self.refresh()"), e.next = 14, r._refresh();

                  case 14:
                    n.headers.common.Authorization = "Bearer " + r.accessToken, v.log("Authorization header set bearer");

                  case 16:
                    return e.abrupt("return", n);

                  case 17:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (t) {
            return e.apply(this, arguments);
          }), function (e) {
            return Promise.reject(e);
          }), this.axios.interceptors.response.use(function (e) {
            return e;
          }, function (e) {
            return v.log(e), v.log("error.response:", e.response), r._checkIfLogoutNeeded(e.response), v.log("Response error, reject(error)"), Promise.reject(e);
          });
        }
      }, {
        key: "_checkIfLogoutNeeded",
        value: function value(e) {
          try {
            var t = [this._uri("refresh"), this._uri("authSso"), this._uri("oauthSso"), this._uri("switchAccount")];
            v.log("allAuthUrls", t), v.log("response", e), e && e.status && (401 === e.status || 401 === e.status) && e.config && t.includes(e.config.url) ? (v.log("error.response.config.url", e.config.url), v.log("this.logout() is needed!"), this.logout()) : v.log("logout() is not needed.");
          } catch (e) {
            v.error(e);
          }
        }
      }, {
        key: "_uri",
        value: function value(e) {
          return this.options.url + this.options[e + "Url"];
        }
      }, {
        key: "_refresh",
        value: function value(e) {
          var t = this;
          return v.log("self.refresh()"), this._runSyncedAuthenticationRequest(function () {
            if (e) return v.info("RUN REFRESH. force"), t._refreshRequest();

            var r = t._getMillisecondsLeftToExpire();

            return r <= t.options.refreshBeforeExpireSec ? t._isTokenValid() ? (v.info("RUN REFRESH. tokenValid, mlsLeft:", r), t._refreshRequest(), new Promise(function (e) {
              var r = t._getRandomTimeout();

              setTimeout(function () {
                v.log("Run parallel refresh", r), e("Run parallel refresh");
              }, r);
            })) : (v.info("RUN REFRESH. tokenInvalid, mlsLeft:", r), t._refreshRequest()) : (v.log("refresh token not needed"), Promise.resolve("Refresh token not needed").then(function (e) {
              return v.log("refresh token not needed"), t._clearRunningRefreshPromise(), v.log("Clear local lock"), t._removeLock(), Promise.resolve(e);
            }));
          });
        }
      }, {
        key: "_getRandomTimeout",
        value: function value() {
          return 20 * (this.idthrdOrder || 0) + 10;
        }
      }, {
        key: "_refreshRequest",
        value: function value() {
          var e = this;
          if (v.log("this._refreshRequest()"), !this.refreshToken) return Promise.reject("Refresh token is empty");
          var t = {};
          t[this.options.refreshToken] = this.refreshToken;
          var r = {
            headers: {
              uniqueId: this.uniqueId
            }
          };
          return this._attachRequestQuarterback(this.axios.post(this._uri("refresh"), t, r)).then(function (t) {
            return v.log("then this._refresh  tokenValid after Refresh"), e._clearRunningRefreshPromise(), e._removeLock(), Promise.resolve(t);
          }).catch(function (t) {
            return v.log("catch this._refresh tokenValid after Refresh"), e._clearRunningRefreshPromise(), e._removeLock(), Promise.reject(t);
          });
        }
      }, {
        key: "_attachRequestQuarterback",
        value: function value(e, t) {
          var r = this;
          return t = t || {}, this.loading = !0, e.then(function (e) {
            return r._receivethMightyToken(e.data), r.loading = !1, Promise.resolve(e);
          }).catch(function (e) {
            return r.loading = !1, v.log("error. loading false"), Promise.reject(e);
          });
        }
      }, {
        key: "_checkClockSkew",
        value: function value(e) {
          v.log("Check Clock Skew"), this.clockSkew = Math.floor(Date.now() / 1e3 - this.jwtPayload.iat), v.log("Detected Clock Skew: ".concat(this.clockSkew, " sec"));
        }
      }, {
        key: "_parseJWT",
        value: function value(e) {
          var t = k(e);
          this.jwtPayload = Object.assign({}, t), this.user && this.user.sub && this.user.sub === t.sub ? (v.log("user set(update): ", this.user, " ->", t), this.user = Object.assign({}, this.user, t)) : (v.log("user set(clear):", this.user, " ->", t), this.user = Object.assign({}, t)), this.issuedAt = this.jwtPayload.iat, this.notBefore = this.jwtPayload.nbf, this.expires = this.jwtPayload.exp, this.issuedAt && (this.issuedAtDate = new Date(1e3 * this.issuedAt), v.log("Parse new accessToken issuedAtDate: " + this.issuedAtDate.toJSON())), this.expiresDate = new Date(1e3 * this.expires), v.log("Parse new accessToken expiresDate:", this.expiresDate.toJSON());
        }
      }, {
        key: "_setRefreshToken",
        value: function value(e) {
          this.refreshToken = e, v.log("Set new refreshToken");
        }
      }, {
        key: "_isTokenOlder",
        value: function value(e, t) {
          return !!t && k(e).iat <= k(t).iat;
        }
      }, {
        key: "_receivethMightyToken",
        value: function value(e) {
          var t,
              r,
              n = e[this.options.accessToken],
              o = e[this.options.refreshToken];
          if (void 0 === n && void 0 === o) return r = {
            code: -1,
            http: null
          }, void 0 !== (t = "No token/refresh-token received").status ? (r.code = t.status, r.error = t.statusText, r.data = t.data ? t.data.errors : null, r.http = t, r.message = function (e) {
            return "Connection Issue" === e.error ? "Could not connect" : "Bad Request" === e.error ? "Invalid data" : "Token Expired" === e.error ? "Token Expired" : 500 === e.code ? "Server Error" : 404 === e.code ? "Not Found" : 403 === e.code ? "Forbidden" : 401 === e.code ? "Unauthorized" : "Unknown error";
          }(r)) : r.message = "string" == typeof t ? r.error = t : t.error = t.message, v.error("[VueIdentity Error]", r), Promise.reject(r);
          this.tokenPair = {
            refreshToken: o,
            accessToken: n
          }, this._checkClockSkew(this.jwtPayload);
        }
      }, {
        key: "_getMillisecondsLeftToExpire",
        value: function value() {
          var e = 1e3 * (this.expires + this.clockSkew - 1) - Date.now();
          return v.info("attemptRefresh mlsLeft=", e, ", options['refreshBeforeExpireSec']=", this.options.refreshBeforeExpireSec), e;
        }
      }, {
        key: "_resolveRunningRefreshPromise",
        value: function value(e) {
          v.log("resolveRunningRefreshPromise:", e), this._clearRunningTimeout(), this.runningRefreshPromiseResolve && (v.log("resolve waiting promise"), this._runningRefreshPromiseResolve(e), this.runningRefreshPromiseResolve = null);
        }
      }, {
        key: "_runSyncedAuthenticationRequest",
        value: function value(e) {
          var t = this;
          return this.runningRefreshPromise ? v.log("this.runningRefreshPromise is not empty") : (v.log("!this.runningRefreshPromise"), this._setLock() ? (v.log("Is not locked. Run promise runSyncedAuthenticationRequest"), this.runningRefreshPromise = e().then(function (e) {
            return v.log("runningRefreshPromise OK", e), Promise.resolve(e);
          }).catch(function (e) {
            return v.log("runningRefreshPromise Error", e), Promise.reject(e);
          })) : (v.log("IS LOCKED. other refresh() running"), this.runningRefreshPromise = new Promise(function (e) {
            v.log("SET TIMEOUT for already running runningRefreshPromise"), t._resolveRunningRefreshPromise("clear before start timeout"), t.runningRefreshPromiseResolve = e;

            var r = t.options.refreshTokenLockTimeout + t._getRandomTimeout();

            t.refreshTimeoutId = setTimeout(function () {
              v.log("TIMEOUT refreshTokenLockHandle", r), t._clearRunningRefreshPromise(), t._removeLock(!0), t._resolveRunningRefreshPromise("after timeout");
            }, r);
          }).then(function (r) {
            return v.log("this.runningRefreshPromise RESOLVED", r), t._clearRunningRefreshPromise(), new Promise(function (r, n) {
              var o = t._getRandomTimeout();

              setTimeout(function () {
                v.log("runSyncedAuthenticationRequest, after runningRefreshPromise resolve, then", o), t._runSyncedAuthenticationRequest(e).then(function (e) {
                  v.log("runSyncedAuthenticationRequest, after runningRefreshPromise resolve, promise then"), r(e);
                }).catch(function (e) {
                  v.log("runSyncedAuthenticationRequest, after runningRefreshPromise resolve, promise catch"), n(e);
                });
              }, o);
            });
          }).catch(function (e) {
            return Promise.reject(e);
          }))), v.log("return this.runningRefreshPromise"), this.runningRefreshPromise;
        }
      }, {
        key: "_setLock",
        value: function value() {
          return localStorage.getItem(this.options.refreshTokenLockLocalStorageKey) ? (v.log("SET LOCK false uniqueId: ".concat(this.uniqueId)), !1) : (localStorage.setItem(this.options.refreshTokenLockLocalStorageKey, this.uniqueId), v.log("SET LOCK true uniqueId: ".concat(this.uniqueId)), !0);
        }
      }, {
        key: "_clearRunningRefreshPromise",
        value: function value() {
          this._clearRunningTimeout(), v.log("clear runningRefreshPromise"), this.runningRefreshPromise = null;
        }
      }, {
        key: "_clearRunningTimeout",
        value: function value() {
          null !== this.refreshTimeoutId && (v.log("CLEAR TIMEOUT: ", this.refreshTimeoutId), clearTimeout(this.refreshTimeoutId), this.refreshTimeoutId = null);
        }
      }, {
        key: "_removeLock",
        value: function value(e) {
          return v.log("REMOVE LOCK uniqueId: ".concat(this.uniqueId, ", force: ").concat(e)), e || localStorage.getItem(this.options.refreshTokenLockLocalStorageKey) === this.uniqueId ? (localStorage.removeItem(this.options.refreshTokenLockLocalStorageKey), !0) : (v.log("REMOVE LOCK FALSE"), !1);
        }
      }, {
        key: "_isLocked",
        value: function value() {
          var e = localStorage.getItem(this.options.refreshTokenLockLocalStorageKey);
          return v.log("IS LOCKED uniqueId: ".concat(e)), !!localStorage.getItem(this.options.refreshTokenLockLocalStorageKey);
        }
      }, {
        key: "authenticate",
        value: function () {
          var e = a()(i.a.mark(function e(t) {
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (e.prev = 0, v.log("this.authenticate..."), !this._isTokenValid()) {
                      e.next = 4;
                      break;
                    }

                    return e.abrupt("return");

                  case 4:
                    if (v.log("this.authenticate !this.isTokenValid()"), !this.refreshToken) {
                      e.next = 18;
                      break;
                    }

                    return e.prev = 6, e.next = 9, this._refresh(t);

                  case 9:
                    v.log("self.authenticate after Refresh"), e.next = 16;
                    break;

                  case 12:
                    throw e.prev = 12, e.t0 = e.catch(6), v.log("authenticate refresh() error", e.t0), e.t0;

                  case 16:
                    e.next = 19;
                    break;

                  case 18:
                    throw new Error("You're not logged in");

                  case 19:
                    return e.prev = 19, this._updateLoggedInStatus(), e.abrupt("return");

                  case 23:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[0,, 19, 23], [6, 12]]);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "login",
        value: function value(e) {
          var t = this,
              r = {};
          return this.user = null, v.log("user set(login, clear): null"), this._runSyncedAuthenticationRequest(function () {
            return t._attachRequestQuarterback(t.axios.post(t._uri("login"), e, {
              credentials: !0,
              params: r
            })).then(function (e) {
              return v.log("then after Login"), t._clearRunningRefreshPromise(), t._removeLock(), Promise.resolve(e);
            }).catch(function (e) {
              return v.log("catch after Login"), t._clearRunningRefreshPromise(), t._removeLock(), Promise.reject(e);
            });
          });
        }
      }, {
        key: "ssoLogin",
        value: function value(e) {
          var t = this,
              r = {};
          return this.user = null, this._updateLoggedInStatus(), v.log("user set(ssoLogin, clear): null"), this._runSyncedAuthenticationRequest(function () {
            return t._attachRequestQuarterback(t.axios.post(t.options.ssoLoginUrl, e, {
              credentials: !0,
              params: r
            })).then(function (e) {
              return v.log("then after ssoLogin"), t._clearRunningRefreshPromise(), t._removeLock(), Promise.resolve(e);
            }).catch(function (e) {
              return v.log("catch after ssoLogin"), t._clearRunningRefreshPromise(), t._removeLock(), Promise.reject(e);
            });
          });
        }
      }, {
        key: "loginOAuth",
        value: function value(e) {
          var t = this,
              n = {};
          return this._runSyncedAuthenticationRequest(function () {
            return t._attachRequestQuarterback(t.axios.post(t._uri("oauthSso"), e, {
              credentials: !0,
              params: n
            })).then(function (e) {
              return v.log("then after self.loginOAuth", e), t._clearRunningRefreshPromise(), t._removeLock(), Promise.resolve(e);
            }).catch(function (e) {
              return v.log("catch after this.loginOAuth", e), t._clearRunningRefreshPromise(), t._removeLock(), Promise.resolve(r);
            });
          });
        }
      }, {
        key: "loginAuth",
        value: function value(e) {
          var t = this,
              r = {};
          return this._runSyncedAuthenticationRequest(function () {
            return t._attachRequestQuarterback(t.axios.post(t._uri("authSso"), e, {
              credentials: !0,
              params: r
            })).then(function (e) {
              return v.log("then after this.loginAuth", e), t._clearRunningRefreshPromise(), t._removeLock(), Promise.resolve(e);
            }).catch(function (e) {
              return v.log("catch after this.loginAuth"), t._clearRunningRefreshPromise(), t._removeLock(), Promise.reject(e);
            });
          });
        }
      }, {
        key: "userInfo",
        value: function value() {
          var e = this;
          return this.axios.get(this._uri("userinfo"), {
            credentials: !0,
            params: {}
          }).then(function (t) {
            return e.user = Object.assign({}, e.user, t.data), Promise.resolve(t);
          }).catch(function (e) {
            return Promise.reject(e);
          });
        }
      }, {
        key: "getServiceSsoUrl",
        value: function value(e, t, r) {
          return void 0 === r && (r = {}), this.axios.post(this._uri("serviceSso"), {
            target_sso: e,
            target_url: t,
            params: r
          }).then(function (e) {
            return e.data && e.data.url ? Promise.resolve(e.data.url) : Promise.reject("No url in response");
          });
        }
      }, {
        key: "goToServiceSSO",
        value: function value(e, t, r) {
          var n = this;
          return new Promise(function (o, i) {
            n.getServiceSsoUrl(e, t, r).then(function (e) {
              v.log("Redirect to target service: ".concat(e)), location.href = e, o(e);
            }).catch(function (e) {
              i(e);
            });
          });
        }
      }, {
        key: "getRedirectToServiceSSOUrl",
        value: function value(e, t) {
          void 0 === t && (t = {}), t.target_url || (t.target_url = window.location.href);
          var r = "target_sso=" + e + "&target_url=" + t.target_url;
          t.scope && (r += "&scope=" + t.scope), t.account_id && (r += "&account_id=" + t.account_id), t.td_installation_id && (r += "&td_installation_id=" + t.td_installation_id), t.td_user_id && (r += "&td_user_id=" + t.td_user_id);
          var n = this.frontendBaseUrl + "/" + encodeURI("?" + r);
          return v.log("getRedirectToServiceSSOUrl: ", n), n;
        }
      }, {
        key: "logout",
        value: function () {
          var e = a()(i.a.mark(function e() {
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (v.log("logout()"), e.prev = 1, v.log("logout api call"), !this.tokenPair.accessToken) {
                      e.next = 6;
                      break;
                    }

                    return e.next = 6, this.axios.get(this._uri("logout"), {
                      timeout: 5e3
                    });

                  case 6:
                    e.next = 11;
                    break;

                  case 8:
                    e.prev = 8, e.t0 = e.catch(1), v.log("logout api call error", e.t0);

                  case 11:
                    return e.prev = 11, v.log("logout clear tokens and all things..."), this._clearRunningRefreshPromise(), this._removeLock(!0), this.refreshToken = null, this.accessToken = null, this.clockSkew = null, this.user = null, v.log("user set(logout): null"), this.jwtPayload = null, this.expires = null, this.issuedAt = null, this.notBefore = null, this._updateLoggedInStatus(), this.tokenPair && (this.tokenPair.accessToken || this.tokenPair.refreshToken) && (this.tokenPair = {
                      refreshToken: null,
                      accessToken: null
                    }), e.finish(11);

                  case 27:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[1, 8, 11, 27]]);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "switchAccount",
        value: function value(e, t) {
          var r = {
            account_id: e
          };
          return t && (r.scope = t), this._attachRequestQuarterback(this.axios.post(this._uri("switchAccount"), r));
        }
      }, {
        key: "hasPermission",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".",
              r = !1;
          return this.user && this.user.allow && (r = function e(t, r) {
            try {
              if (!t || !r) return !1;
              if (!Array.isArray(r)) return t[0] in r ? !(t.length > 1) || e(t.slice(1), r[t[0]]) : "*" in r;
              if (Array.isArray(r)) return r.includes(t[0]) ? !(t.length > 1) || e(t.slice(1), r[t[0]]) : r.includes("*");
            } catch (e) {
              return !1;
            }
          }(e.split(t), this.user.allow)), r;
        }
      }, {
        key: "initialize",
        value: function value(e) {
          this._created(), "function" == typeof e && e();
        }
      }, {
        key: "expiresIn",
        get: function get() {
          return !!this.expires && 1e3 * this.expires - Date.now();
        }
      }, {
        key: "idthrd",
        get: function get() {
          return "idthrd:" + this.uniqueId;
        }
      }, {
        key: "frontendBaseUrl",
        get: function get() {
          return this.options.baseUrl ? this.options.baseUrl : this.options.url.substring(0, this.options.url.lastIndexOf("/identity"));
        }
      }], [{
        key: "publicMethods",
        get: function get() {
          return ["initialize", "authenticate", "login", "ssoLogin", "loginOAuth", "loginAuth", "userInfo", "getServiceSsoUrl", "goToServiceSSO", "getRedirectToServiceSSOUrl", "logout", "switchAccount", "hasPermission"];
        }
      }, {
        key: "publicData",
        get: function get() {
          return m;
        }
      }]), e;
    }();

    t.default = _;
  }]);
});